import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/benchmarks/page.tsx");
